// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header[data-v-3acbc2e8]{background:var(--g-color-light-green);color:var(--g-color-on-primary);height:3.125rem;padding:0;position:relative;z-index:100}.header .grid[data-v-3acbc2e8]{align-items:center;display:flex;height:100%;justify-content:space-between}.header__logo[data-v-3acbc2e8]{display:inline-flex;text-decoration:none}.header__nav-list[data-v-3acbc2e8]{list-style:none;margin:0;padding-left:0;display:flex}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
